import { useEffect } from "react";

function AppRouteActionHandler(props) {
  const { showAppTitle, clearCurrentDataSegment, appStateActions, dataSegmentActions, sessionActions } = props;

  useEffect(() => {
    if (showAppTitle !== undefined) {
      console.log("setting showAppTitle to " + showAppTitle);
      appStateActions.showAppTitle(showAppTitle);
    }
  
    if (clearCurrentDataSegment) {
      console.log("setting current DataSegment and current Session to null");
      dataSegmentActions.clearDataSegment();
      sessionActions.setCurrentSession();
    }
  }, [showAppTitle, clearCurrentDataSegment]);

  return (
    props.children
  );
}

export default (AppRouteActionHandler);
